// In-memory search / filter / sort state for the dashboard list tables
// (StudentListTable, StaffListTable), so opening a profile and coming back
// shows the list as it was left. Cleared on a full page reload, and when the
// table is left for anything other than a profile page.

const store = {};

export const getListViewState = (key) => store[key] || null;

export const saveListViewState = (key, state) => {
    store[key] = state;
};

export const clearListViewState = (key) => {
    delete store[key];
};

// Keep the saved state only when navigating to a student / staff profile.
export const isProfilePath = (pathname = "") => /\/(student|staff)-profile(\/|$)/.test(pathname);
